// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1Lbra","title":"AfterBackImages_title__3VjcK","images":"AfterBackImages_images__2cNXk"};